<template>
  <div id="app">
    <navbar></navbar>

      <keep-alive>
        <router-view v-if="$route.meta.keepAlive"></router-view>
      </keep-alive>

      <router-view v-if="!$route.meta.keepAlive"></router-view>

    <foot></foot>
  </div>
</template>

<script>
import NavBar from '@/components/Navbar'
import Footer from '@/components/Footer'

export default {
  components: {
    'navbar': NavBar,
    'foot': Footer
  },
  name: 'app'
}
</script>

<style lang="scss">

  .fadeIn-enter-active {
    transition-delay: .25s;
  }

  .fadeIn-enter-active, .fadeIn-leave-active {
    transition-property: opacity;
    transition-duration: .25s;
  }


  .fadeIn-enter, .fadeIn-leave-active {
    opacity: 0
  }

   @import 'assets/stylesheets/site.css.sass'

</style>



// WEBPACK FOOTER //
// src/App.vue